"use client"
import React, { useState } from 'react';
import CountryAndStateInputs from '@/Inputs/CountryAndState.Input';
import LoaderComponent from '@/Inputs/LoaderComponent';
import TextFieldComponent from '@/Inputs/TextFieldComponent';
import GoogleAutocomplete from '@/comman/GoogleAutocomplete';
const InputFieldValue = ({
    name, label, values, handleChange, errors, divClass = "",
    handleBlur, setFieldValue, _onHandle
}) => (
    <TextFieldComponent
        name={name}
        value={values?.[name]}
        onChange={(e) => handleChange(e)}
        onBlur={(e) => {
            handleBlur(e);
            _onHandle(e, values)
        }}
        id={name}
        placeholder=""
        label={label}
        errorMessage={errors?.[name]}
        divClass={'sm:w-full w-full'}
    />
);

const AddressForm = (props) => {
    const {
        fieldValue,
        handleChangeFunction,
        normalAddressError,
        countryState,
        setCountryState,
        _handelGooglePlace,
        checkoutError,
        isLoading,
        isUserLogin
    } = props;


    const [additionalAddressFields, setAdditionalAddressFields] = useState(1);

    const handleAddAddressField = () => {
        setAdditionalAddressFields((prevFields) => prevFields + 1);
    };
    return (
        <>
            {isLoading && <LoaderComponent />}
            {isUserLogin &&
                <>
                    <InputFieldValue name='shipping_urname' label="First name" _onHandle={handleChangeFunction} {...fieldValue} />
                    <InputFieldValue name='shipping_lastname' label="Last name" _onHandle={handleChangeFunction} {...fieldValue} />
                </>
            }
            <div className='flex flex-wrap'>
                <div className="w-full xl:mb-[24px] lg:mb-[24px] mb-[16px]">
                    <GoogleAutocomplete
                        icon={<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                        </svg>}
                        defaultValue={fieldValue?.values?.shipping_street}
                        onChange={(val) => {
                            fieldValue?.setFieldValue(`shipping_street`, val);
                        }}
                        manually={false}
                        label={`Address`}
                        InputClassName="pl-3.5"
                        LabelClassName="!pl-0"
                        callback={(data) => _handelGooglePlace(data, 'placeOrder', fieldValue)}
                    />
                    {fieldValue?.errors?.shipping_street && <p className="mt-1 text-sm text-red-500" >{fieldValue?.errors?.shipping_street}</p>}
                    <p className='text-sm text-red-500 mt-1'>{normalAddressError || checkoutError || ''}</p>
                </div>

                {(additionalAddressFields < 2 && !fieldValue?.values?.shipping_street2) &&
                    <span className="text-sm text-blue  mb-[24px]" onClick={() => handleAddAddressField()}>
                        +Add apartment, suite, etc (optional)
                    </span>
                }
                {(additionalAddressFields === 2 || fieldValue?.values?.shipping_street2) &&
                    <InputFieldValue divClass="w-full" name="shipping_street2" label="Address 2" _onHandle={handleChangeFunction} {...fieldValue} />
                }
                <CountryAndStateInputs {...{
                    countryState, setCountryState, onChange: (val, sec) => {
                        if (sec === 'state') {
                            fieldValue?.setFieldValue('shipping_state', val);
                        } else {
                            fieldValue?.setFieldValue('shipping_country', val);
                        }
                    }
                }} />
                <div className="flex sm:flex-nowrap flex-wrap sm:gap-4 w-full">
                    <InputFieldValue name='shipping_zipcode' label="ZIP code" _onHandle={handleChangeFunction} {...fieldValue} />
                    <InputFieldValue name='shipping_city' label="City" _onHandle={handleChangeFunction} {...fieldValue} />
                </div>
            </div>

        </>

    )
}

export default AddressForm;